import { COMMON_EVENT_NAMES } from "../../constants";

export const EVENT_NAME = {
  OPEN_INBOX: "Open",
  HOME_NAVIGATION: COMMON_EVENT_NAMES.NAVIGATED,
  IOS_TRACKING_PERMISSION: "Appsflyer modal"
};
